import {createSelector} from 'reselect';

import {STATUS_TEXT, CANCELLED_KEY, FAILED_KEY} from './myaccount-constants';

export const myTripsHeaders = state => state.myaccount.headers;
export const activeTab = state => state.myaccount.activeTab;
export const loading = state => state.myaccount.loading;
export const statementLoader = state => state.myaccount.statementLoader;
export const myTripBookings = state => state.myaccount.myTripBookings;
export const userDetails = state => state.myaccount.userDetails;
export const detailsParams = state => state.myaccount.detailsParams;
export const childID = state => state.myaccount.detailsParams?.childID;
export const detailsBookingData = state => state.myaccount.myTripBookingDetails;
export const detailsPaymentData = state => state.myaccount.myTripPaymentDetails;
export const activeCancellationTab = state => state.myaccount.activeCancellationTab;
export const cancellationData = state => state.myaccount.cancellationData;
export const selectedRefundMode = state => state.myaccount.selectedRefundMode;
export const refundData = state => state.myaccount.refundData;
export const walletData = state => state.myaccount.walletData;
export const walletBreakupData = state => state.myaccount.walletBreakup;
export const rechargeStatus = state => state.myaccount.rechargeStatus;
export const activeModifyTab = state => state.myaccount.activeModifyTab;
export const modifyHotelData = state => state.myaccount.modifyHotelData;
export const modifyDetails = state => state.myaccount.modifyDetails;
export const modifyStatus = state => state.myaccount.modifyStatus;
export const userSettingData = state => state.user?.userInfo || {};
export const walletType = state => state.myaccount?.walletType;
export const neftLoader = state => state.myaccount?.loadingNeft;
export const supportInfoData = state => state.user?.supportInfo || {};
export const dataMasked = state => state.user?.data_masked;
export const profileInfo = state => state.user?.profileInfo || {};
export const companyInfo = state => state.user?.businessProfile || {};
export const earnMoreData = state => state.user?.earnMore || {};
export const walletPromotionConfigData = state => state.user?.walletPromotionConfig || [];
export const userWalletInfo = state => state.user?.walletInfo || {};
export const vandeBharatData = state => state.user?.vandeBharat || {};
export const loyaltyAgreementDate = state => state.myaccount?.loyaltyAgreementDate || {};
export const loyaltyAgreementDoc = state => state.myaccount?.loyaltyAgreementDoc || {};
export const updateGccUserSetting = state => state?.myaccount?.updateGccUserSetting || {};
export const updateFormFieldsData = state => state?.myaccount?.formFieldData || {};
export const updateRowFieldsData = state => state?.myaccount?.rowFieldsData || {};
export const showCardsMemo = state => state?.myaccount?.showCardsMemo || {};
export const aisCards = state => state?.myaccount?.aisCards || {};
export const editGstFormRow = state => state?.myaccount?.editGstFormRow || {};
export const userInfo = state => state.user || {};

export const myTripsLoaderSelector = createSelector(loading, item => item);
export const myTripsStatementLoaderSelector = createSelector(statementLoader, item => item);
export const myTripsHeadersSelector = createSelector(myTripsHeaders, item => item);
export const myTripsActiveTabSelector = createSelector(activeTab, item => item);
export const myTripsBookingDataSelector = createSelector(myTripBookings, item => item);
export const myTripsUserDataSelector = createSelector(userDetails, item => item);

export const walletDataSelector = createSelector(walletData, item => item);
export const walletBreakupSelector = createSelector(walletBreakupData, item => item);
export const rechargeStatusSelector = createSelector(rechargeStatus, item => item);

export const activeModifyTabSelector = createSelector(activeModifyTab, item => item);
export const myTripModifyHotelDataSelector = createSelector(modifyHotelData, item => item);
export const myTripModifyDetailsSelector = createSelector(modifyDetails, item => item);
export const myTripModifyStatusSelector = createSelector(modifyStatus, item => item);

export const myTripDetailsParamsSelector = createSelector(detailsParams, item => item);
export const myTripDetailsPaymentDataSelector = createSelector(detailsPaymentData, item => item);
export const activeWalletTypeSelector = createSelector(walletType, item => item);

export const neftDetailsLoaderSelector = createSelector(neftLoader, item => item);

export const myTripDetailsBookingDataSelector = createSelector(
  [detailsBookingData, childID],
  (item, childID) => {
    if (item && item[childID]) {
      return item[childID][0];
    }
    return null;
  },
);

export const myTripDetailsHeaderDataSelector = createSelector(
  [detailsBookingData, childID],
  (item, childID) => {
    if (item && item[childID]) {
      return {
        bookingStatusText: STATUS_TEXT(item[childID][0].trip_type.toLowerCase()),
        detailText: item[childID][0].details_message,
        detailSubText: item[childID][0].details_sub_text,
        bookingId: item[childID][0].booking_id,
        pnr: item[childID][0].pnr,
        booking_datetime: item[childID][0].booking_datetime,
        tripType: item[childID][0].trip_type,
      };
    }
    return null;
  },
);

export const myTripPaymentDetailsSelector = createSelector(detailsPaymentData, item => item);

export const myTripBookingDetailsSelector = createSelector(
  [detailsBookingData, childID],
  (item, childID) => {
    if (item && item[childID]) {
      const hotelDetailObj = item[childID][0];
      const {
        hotel_name,
        hotel_address,
        hotel_city,
        hotel_country,
        hotel_pin,
        hotel_contact,
        travel_start_datetime,
        travel_end_datetime,
        room_night,
        rooms,
        room_type,
        inclusion,
        rating,
        quick_actions,
        images,
        location,
        status_text,
      } = hotelDetailObj;
      return {
        hotelName: hotel_name,
        address: hotel_address,
        city: hotel_city,
        country: hotel_country,
        pincode: hotel_pin,
        phone: hotel_contact.phone,
        checkin: travel_start_datetime,
        checkout: travel_end_datetime,
        nights: `${room_night} Night${room_night > 1 ? 's' : ''}`,
        rooms,
        roomType: room_type,
        inclusion,
        starRating: rating ? `${rating} Star Hotel` : '',
        actions: quick_actions,
        image: images[0],
        location,
        statusText: status_text,
      };
    }
    return null;
  },
);

export const myTripHotelDetailsSelector = createSelector(
  [detailsBookingData, childID],
  (item, childID) => {
    if (item && item[childID]) {
      const hotelDetailObj = item[childID][0];
      const {hotel_name, images, amenities, trip_type} = hotelDetailObj;
      const imagesCopy = images.slice();
      const amenitiesCopy = amenities.slice();
      let showHotelDetails = true;
      if (trip_type.toLowerCase() === CANCELLED_KEY || trip_type.toLowerCase() === FAILED_KEY) {
        showHotelDetails = false;
      }
      return {
        showHotelDetails,
        hotelName: hotel_name,
        images: imagesCopy.length > 2 ? imagesCopy : [],
        amenities: amenitiesCopy.length > 9 ? amenitiesCopy : [],
        upforntAmenities: amenitiesCopy.slice(0, 9),
        upforntImages: imagesCopy.slice(0, 2),
        additionalImagesCount: imagesCopy.length - 2,
        additionalAmenitiesCount: amenitiesCopy.length - 9,
      };
    }
    return null;
  },
);

export const myTripDetailsActionLinkSelector = createSelector(
  [detailsBookingData, childID],
  (item, childID) => {
    if (item && item[childID]) {
      const hotelDetailObj = item[childID][0];
      const {actions} = hotelDetailObj;
      return actions;
    }
    return [];
  },
);

export const myTripBookingInfoSelector = createSelector(
  [detailsBookingData, childID],
  (item, childID) => {
    if (item && item[childID]) {
      const hotelDetailObj = item[childID][0];
      const {
        details_message,
        details_sub_text,
        refund_status,
        hotel_name,
        status_message,
      } = hotelDetailObj;
      return {
        header: details_message,
        subHeader: details_sub_text,
        refundStatus: refund_status,
        hotelName: hotel_name,
      };
    }
    return null;
  },
);

export const myTripDetailsImportantInfoSelector = createSelector(
  [detailsBookingData, childID],
  (item, childID) => {
    if (item && item[childID]) {
      const hotelDetailObj = item[childID][0];
      const {trip_type, important_info} = hotelDetailObj;
      let showImpInfo = true;
      if (trip_type.toLowerCase() === CANCELLED_KEY || trip_type.toLowerCase() === FAILED_KEY) {
        showImpInfo = false;
      }
      return {
        important_info,
        showImpInfo,
      };
    }
    return null;
  },
);

export const myTripDetailsPoliciesSelector = createSelector(
  [detailsBookingData, childID],
  (item, childID) => {
    if (item && item[childID]) {
      const hotelDetailObj = item[childID][0];
      const {trip_type, policy, cancel_policy, hotel_policy} = hotelDetailObj;
      let showPolicy = true;
      if (trip_type.toLowerCase() === CANCELLED_KEY || trip_type.toLowerCase() === FAILED_KEY) {
        showPolicy = false;
      }
      return {
        policy: cancel_policy.concat(hotel_policy),
        showPolicy,
      };
    }
    return null;
  },
);

export const activeCancellationTabSelector = createSelector(activeCancellationTab, item => item);

export const cancellationDataSelector = createSelector(cancellationData, item => item);

export const selectedRefundModeSelector = createSelector(selectedRefundMode, item => item);

export const cancellationRefundBreakupDataSelector = createSelector(
  refundData,
  item => item.refund_breakup || null,
);

export const userSettingDataSelector = createSelector(userSettingData, item => item);
export const userWalletInfoSelector = createSelector(userWalletInfo, item => item);
export const supportInfoDataSelector = createSelector(supportInfoData, item => item);
export const vandeBharatDataSelector = createSelector(vandeBharatData, item => item);
export const earnMoreDataSelector = createSelector(earnMoreData, item => item);
export const profileInfoSelector = createSelector(profileInfo, item => item);
export const companyInfoSelector = createSelector(companyInfo, item => item);
export const walletPromotionConfigDataSelector = createSelector(
  walletPromotionConfigData,
  item => item,
);

export const loyaltyAgreementSelector = createSelector(loyaltyAgreementDate, item => item);
export const loyaltyAgreementDocSelector = createSelector(loyaltyAgreementDoc, item => item);
export const gccUserSettingDataSelector = createSelector(updateGccUserSetting, item => item);
export const getFormFieldsDataSelector = createSelector(updateFormFieldsData, item => item);
export const getRowFieldsDataSelector = createSelector(updateRowFieldsData, item => item);
export const showCardsSelector = createSelector(showCardsMemo, item => item);
export const aisCardsSelector = createSelector(aisCards, item => item);
export const popupInfoSelector = createSelector(userInfo, item => item?.updateKycPopup || {});
export const dataMaskedSelector = createSelector(dataMasked, item => item);
